/*
  Keep this module free of imports.

  It is used early in the browser application startup, and should not pull in
  any unnecessary dependencies.
*/

// The path to append to the base url to obtain the API root url
export const API_PATH = 'api/v1';

/**
 * @param rootUrl A url like "https://foo.bar" without the API path
 * @return The url to the API root url like "https://foo.bar/api/v1"
 */
export const ofServiceDocument = (rootUrl: string) => {
  if (rootUrl.endsWith('/'))
    return rootUrl + API_PATH;
  else
    return rootUrl + '/' + API_PATH;
};
